import ConfigSelector from './ConfigSelector';
import { PaginationListType } from '../../../Types/PaginationParams';
import { openApiService } from '../../../Services/openApiService';

interface OpenApiConfig {
    identifier: string;
    title: string;
}

interface OpenApiSelectorProps {
    openApiConfigs: OpenApiConfig[];
    selectedEndpoints: string[];
    onToggleEndpoint: (endpointId: string) => void;
    i18n: any;
}

function OpenApiSelector({ openApiConfigs, selectedEndpoints, onToggleEndpoint, i18n }: OpenApiSelectorProps) {
    const loadEndpoints = async (
        configIdentifier: string,
        page: number,
        itemsPerPage: number,
        query: string | null = null,
    ) => {
        const response = await openApiService.getEndpoints(configIdentifier, page, itemsPerPage, query);
        const endpoints = response.data.data || [];

        const items = endpoints.map((endpoint: any) => ({
            identifier: endpoint.identifier,
            title: endpoint.name,
            deprecated: !!endpoint.metadata?.deprecated,
            description: `${endpoint.method} ${endpoint.path}`,
            config: { identifier: configIdentifier, title: '' },
        }));

        return {
            data: {
                data: items,
                total: response.data.total,
            },
        };
    };

    const getListType = (configIdentifier: string): PaginationListType => {
        return `OpenApiEndpoints_${configIdentifier}` as PaginationListType;
    };

    return (
        <ConfigSelector
            configs={openApiConfigs}
            selectedItems={selectedEndpoints}
            onToggleItem={onToggleEndpoint}
            i18n={i18n}
            itemsFunction={loadEndpoints}
            getListType={getListType}
            placeholders={{
                search: i18n.translate({
                    id: 'search.endpoints',
                    sourceName: 'PromptFunction',
                }),
                empty: i18n.translate({
                    id: 'placeholder.openApiEndpoints',
                    sourceName: 'PromptFunction',
                }),
            }}
        />
    );
}

export default OpenApiSelector;
